import { useState } from 'react'
import API from '../../../../api'

export default function useTranslationRating() {
  const [isLoading, setIsLoading] = useState(false)

  const postRating = async (values) => {
    setIsLoading(true)
    try {
      await API(`${process.env.DOMAIN}/api/v1/translations/ratings/`).post(
        values,
      )
    } catch (e) {
      console.error(e)
    }
    setTimeout(() => {
      setIsLoading(false)
    }, 300)
  }
  return {
    isLoading,
    postRating,
  }
}
